import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import { AppState, history } from 'src';
import {
  saveCustomer,
  addCustomerAddress,
  removeCustomerAddress,
  getCustomerSuccess,
  SaveCustomerSuccessAction,
  SaveCustomerFailureAction,
  getCustomerFromService,
  CustomerActionType
} from 'src/customer/customer.actions';
import { CustomerComponent, CustomerComponentProperties } from 'src/customer/_components/customer/customer.component';
import { CustomerViewModel, initialCustomerVM } from '@models/Customer';
import { getById } from '@common/components/common.actions';
import { actions } from 'react-redux-form';
import FormNames from '@constants/FormNames.enum';
import { RouteDefinitions, getRoute } from '@common/route-definitions';
import { AddressViewModel } from '@models/common.models';

// This is used to translate the state of the page to the props on the component
function mapStateToProps(state: AppState): Partial<CustomerComponentProperties> {
  return {
    message: state.customer.message,
    addresses: state.customer.customerVM.addresses,
    saving: state.customer.saving,
    customerForm: state.customerForm,
    propertyAddress: state.propertyInfoForm.propertyAddress
  };
}

// This should create proxy wrappers for actions used by the component
function mapDispatchToProps(
  dispatch: Dispatch<AppState>,
  ownProps: { saveCallback: Function; isModal: boolean }
): Partial<CustomerComponentProperties> {
  return {
    onSaveClick: (values: CustomerViewModel) => {
      dispatch(saveCustomer(values, ownProps.saveCallback)).then(
        (action: SaveCustomerSuccessAction | SaveCustomerFailureAction) => {
          if (action.type === CustomerActionType.SaveCustomerFailure) {
            return; // if it's a failure, stay here
          }
          if (!ownProps.isModal && action.currentId) {
            history.push(getRoute(RouteDefinitions.customer.Details, { id: action.currentId }));
          } else if (!ownProps.isModal) {
            history.push(getRoute(RouteDefinitions.customer.Search));
          }
        }
      );
    },
    resetForm: () => {
      dispatch(actions.reset(FormNames.CustomerForm));
      dispatch(actions.change(FormNames.CustomerForm + '.usps', initialCustomerVM.usps));
      dispatch(actions.change(FormNames.CustomerForm + '.customerType', initialCustomerVM.customerType));
      dispatch(actions.change(FormNames.CustomerForm + '.customerStatus', initialCustomerVM.customerStatus));
      dispatch(actions.change(FormNames.CustomerForm + '.language', initialCustomerVM.language));
      dispatch(actions.change(FormNames.CustomerForm + '.addresses', initialCustomerVM.addresses));
    },
    setAddressOnePrimary: () => {
      dispatch(actions.change(FormNames.CustomerForm + '.addresses[0].primary', true));
    },
    getCustomer: (id: number) => {
      dispatch(getById<CustomerViewModel>(id, getCustomerFromService)).then(customer => {
        if (!customer) {
          return;
        }

        dispatch(getCustomerSuccess(customer));
        dispatch(actions.load(FormNames.CustomerForm, customer));
      });
    },
    addAddressClick: (address?: AddressViewModel) => {
      dispatch(addCustomerAddress(address));
    },
    removeAddressClick: (index: number) => {
      dispatch(removeCustomerAddress(index));
    }
  };
}

// Connect function "wires" both of the map functions and returns a wrapper container for the component
export const Customer = connect(
  mapStateToProps,
  mapDispatchToProps
)(CustomerComponent);



// WEBPACK FOOTER //
// ./src/customer/_components/customer/customer.container.ts